import React, { useState } from 'react';
import { ActionsDropdown } from '@components/library/dropdown/index';
import { ActionDropdownItem } from '@components/library/dropdown_item/index';
import { TertiaryIconButton } from '@components/library/button/index';
import PortalForm from './portal_form';

interface PortalSettingsProps {
  editMode: boolean;
  showSettingsDropdown: boolean;
  setShowSettingsDropdown: SetStateDispatch<boolean>;
  showForm: boolean;
  toggleEditMode: () => void;
  toggleForm: () => void;
}

const PortalSettings: React.FunctionComponent<PortalSettingsProps> = (props) => {
  const [closeDropdown, setCloseDropdown] = useState(false);

  const anchorElement = (
    <TertiaryIconButton
      className="ellipsis-button"
      icon="bff-ellipsis"
      iconSize={20}
    />
  );

  return (
    <>
      <ActionsDropdown
        anchorElement={anchorElement}
        className="portal-header__dropdown"
        closeCallback={(): void => setCloseDropdown(false)}
        closeDropdown={closeDropdown}
        openOnClick
        openOnHover={false}
        userDevice={BFG.currentUser.device}
      >
        <ActionDropdownItem
          icon="bff-settings"
          name="portal-settings"
          onChoose={(): void => {
            props.toggleForm();
            setCloseDropdown(true);
          }}
        >
          {t("Portal Settings")}
        </ActionDropdownItem>
        <ActionDropdownItem
          icon="bff-eye"
          name="edit-mode"
          onChoose={(): void => {
            props.toggleEditMode();
            setCloseDropdown(true);
          }}
        >
          {props.editMode ? t("Switch to Preview Mode") : t("Switch to Edit Mode")}
        </ActionDropdownItem>
      </ActionsDropdown>
      {props.showForm && <PortalForm closeModal={props.toggleForm} />}
    </>
  );
};

export default PortalSettings;
